import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from './types';

const SgforgeLogoIcon: FC<SVGIconType> = ({ color, size = 32 }) => {
  const colorClasses = css({
    color: color || 'rgba(0, 0, 0, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  // Calculate height based on original aspect ratio (1466:1539)
  // const aspectRatio = 1539 / 1466;

  // const height = Math.round(size * aspectRatio);

  return (
    <div
      data-testid="bp-logo-icon"
      className={colorClasses}
      style={{ width: size, height: 'auto' }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M12.813 33.3813H5.52148V1.625H29.4775V7.49544H12.813V33.3813Z"
          fill="black"
        />
        <path
          d="M29.9775 1.125V7.99512H13.3135V33.8809H5.02148V1.125H29.9775ZM6.02148 32.8809H12.3135V6.99512H28.9775V2.125H6.02148V32.8809Z"
          fill="black"
        />
        <path
          d="M16.957 15.8594H23.5588V21.9246H16.957V15.8594Z"
          fill="#E9041E"
        />
      </svg>
    </div>
  );
};

const SgforgeInvertedLogoIcon: FC<SVGIconType> = ({ color, size = 32 }) => {
  const colorClasses = css({
    color: color || 'rgba(0, 0, 0, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <div
      data-testid="bp-logo-icon"
      className={colorClasses}
      style={{ width: size, height: 'auto' }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M12.8135 33.3783H5.52197V1.62207H29.478V7.49251H12.8135V33.3783Z"
          fill="white"
        />
        <path
          d="M29.978 1.12207V7.99219H13.314V33.8779H5.02197V1.12207H29.978ZM6.02197 32.8779H12.314V6.99219H28.978V2.12207H6.02197V32.8779Z"
          fill="white"
        />
        <path
          d="M16.958 15.8594H23.5598V21.9246H16.958V15.8594Z"
          fill="#E9041E"
        />
      </svg>
    </div>
  );
};

export { SgforgeLogoIcon, SgforgeInvertedLogoIcon };
